<div class="copyClipboard" (click)="copyTextToClipboard()">
    <div>
        <ng-content></ng-content>
    </div>
    <span  [attr.title]="isCopied ? 'Copied' : 'Copy to Clipboard'"><img class="btn-copy" src="../../../../assets/copy-clipboard.svg" alt="copy to clipboard"></span>
</div>
